<template>
    <span class="jo-vocab">
      <span v-for="(item,index) in data" v-bind:key="index">
      <component :is="'jo' + item.name" v-bind:data="item.data"></component>{{item.name=='sup' && index==data.length-1?'\xa0\xa0\xa0\xa0':''}}</span>
    </span>
</template>

<script>
  export default {
    /*data() {
      return {
        hideVocab: false,
      }
    },*/
    props: [
      'data',
      'hideVocab'
    ],
    created() {
      /*if (this.$parent.$parent.hideVocab) {
        this.hideVocab = this.$parent.$parent.hideVocab
      }*/
      var data = this.data;
      for(var i = 0;i < data.length; i++){
        if (data[i].name==='text'){
          let text = data[i].data;
          if(text.substring(text.length - 1, text.length) != ' '){
            this.data[i].data = text + '\xa0\xa0';
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jo-vocab {
    font-size: 1.4rem;
    font-weight: bold;
    color: #333;
  }

  /*.jo-table-note {
    .jo-vocab {
      display: none;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/common/vocab.vue